module.exports = __webpack_public_path__ + "img/noGroupDataReport.1f034a00.svg";